import { Injectable, inject } from '@angular/core';

import { BreadcrumbsData, Dimension, ReportDashboardComponentKind } from '@core/reports-types';

import { DetailsFunnelBreadcrumbsService } from './details-funnel-breadcrumbs.service';
import { DetailsGenericBreadcrumbsService } from './details-generic-breadcrumbs.service';
import { DetailsNetChangeBreadcrumbsService } from './details-net-change-breadcrumbs.service';
import { DetailsTrendBreadcrumbsService } from './details-trend-breadcrumbs.service';

@Injectable()
export class ReportsComponentDetailsBreadcrumbsService {
  private trend = inject(DetailsTrendBreadcrumbsService);
  private generic = inject(DetailsGenericBreadcrumbsService);
  private funnel = inject(DetailsFunnelBreadcrumbsService);
  private netChange = inject(DetailsNetChangeBreadcrumbsService);

  public getDetailsBreadcrumbs(
    breadcrumbsSettings: BreadcrumbsData,
    initialDimensions: { primary: Dimension; secondary?: Dimension | Dimension[] },
  ) {
    const sec = initialDimensions.secondary ?? [];
    const dimensions = {
      primary: initialDimensions.primary,
      secondary: Array.isArray(sec) ? sec : [sec],
    };
    switch (breadcrumbsSettings.kind) {
      case ReportDashboardComponentKind.Trend:
        return this.trend.getBreadcrumbs({ breadcrumbsSettings, dimensions });
      case ReportDashboardComponentKind.NetChange:
        return this.netChange.getBreadcrumbs({ breadcrumbsSettings, dimensions });
      case ReportDashboardComponentKind.Funnel:
        return this.funnel.getBreadcrumbs({ breadcrumbsSettings, dimensions });
      default:
        return this.generic.getBreadcrumbs({ breadcrumbsSettings, dimensions });
    }
  }
}
